import { $api } from "@/shared/api";

// Серия для экрана (`GET /api/drills/series`): незаконченная, недавно законченная (итог)
// или новая из задач, которые можно дать сейчас. Задач нет — `series: null`.
export const useDrillSeries = () => $api.useQuery("get", "/api/drills/series");
